import { decamelizeKeys } from 'humps';
import move from 'array-move';

import resolve from '../../../../api-client';
import { getPagesCopyUrl, getPagesUrl, getPagesItemUrl, getPagesSortUrl } from '../../util';
import {
  PAGES__COPY,
  CONFIRM_MODAL__DYNAMIC_TEXT,
  PAGES__CREATE,
  PAGES__DELETE,
  PAGES__FETCH,
  PAGES__PATCH,
  PAGES__REPLACE,
  PAGES__SORT,
  PAGES__UPDATE,
} from '../constants';
import { selectPageRefs } from '../selectors';

export const pagesCopy = (organizationId, surveyId, pageId) =>
  resolve({
    url: getPagesCopyUrl(pageId),
    method: 'post',
    type: PAGES__COPY,
    data: decamelizeKeys({
      organizationId,
      surveyId,
    }),
    pageId,
  });
export const pagesCreate = (organizationId, surveyId, position, layoutId) =>
  resolve({
    url: getPagesUrl(),
    method: 'post',
    type: PAGES__CREATE,
    data: decamelizeKeys({
      organizationId,
      surveyId,
      position,
      layoutId,
    }),
  });

export const pagesBeforeDelete = (pageId, confirm) => (dispatch, getState) => {
  const extra = {
    list: selectPageRefs(getState(), pageId),
    type: 'page',
  };
  return confirm('Delete Slide?', CONFIRM_MODAL__DYNAMIC_TEXT, extra);
};
export const pagesDelete = ({ nextPageId, pageId, organizationId, surveyId }) =>
  resolve({
    url: getPagesItemUrl(pageId),
    method: 'delete',
    type: PAGES__DELETE,
    data: decamelizeKeys({
      organizationId,
      surveyId,
      id: pageId,
    }),
    nextPageId,
  });

export const pagesFetch = (organizationId, surveyId) =>
  resolve({
    type: PAGES__FETCH,
    url: getPagesUrl(),
    params: decamelizeKeys({
      organizationId,
      surveyId,
    }),
  });

export const pagesSort = (organizationId, surveyId, pages, position, nextPosition) =>
  resolve({
    data: decamelizeKeys({
      organizationId,
      surveyId,
      positionChanges: move(pages, position, nextPosition)
        .map((page, key) => ({
          id: page.id,
          change: key + 1 - page.position,
        }))
        .filter(({ change }) => change !== 0),
    }),
    method: 'put',
    pages,
    type: PAGES__SORT,
    url: getPagesSortUrl(),
  });

export const pagesUpdate = (organizationId, surveyId, page, newProps) => (dispatch) => {
  dispatch({
    type: PAGES__PATCH,
    page,
    newProps,
  });

  const pageId = page.id;
  const params = decamelizeKeys({
    organizationId,
    surveyId,
    pageId,
  });
  const data = decamelizeKeys(newProps);

  dispatch(
    resolve({
      method: 'put',
      type: PAGES__UPDATE,
      url: getPagesItemUrl(pageId),
      data,
      params,
    }),
  ).catch(() => dispatch({ type: PAGES__REPLACE, page }));
};

/**
 * @see docs/worklog/maintenance/19738-select-new-slide-after-copy/rfc.md
 * @see docs/worklog/maintenance/19738-select-new-slide-after-copy/tfc.md
 */
